<template>
	<el-popover placement="bottom" width="920" trigger="hover" append-to-body @after-leave="imgLoading=false"
		:close-delay="150" ref="dcPopover"
		@show="showPopper(null)" :open-delay="150"  :popper-append-to-body="false">
		<div class="asin-data-div" v-if="imgLoading">
			<div style="display: flex">
				<div class="big-img-div">
					<el-image slot="reference" fit="scale-down" style="height:100%;width:100%;vertical-align: middle;"
						:src="asinRelated.images ? asinRelated.images[0].link.replace('.jpg','._SL450_.jpg') : ''">
						<div slot="placeholder">
							<i class="el-icon-loading"></i>
						</div>
						<div slot="error" style="text-align: center;width:100%;">
							<i class="el-icon-picture-outline"></i>
						</div>
					</el-image>
					<div class="ranking-div">
						{{ asinRelated.rank }}
					</div>
				</div>
				<div style="flex: 1; margin-left: 15px;">
                    <div class="asin-title-div">
							<el-tooltip effect="light" placement="top" :content="asinRelated.product_title || asinRelated.title">
								<a target="_blank" :href="'https://www.'+ getCountryObjByCity(country).department +'/dp/' + asinRelated.asin + '?&_encoding=UTF8&tag=yuzone00-20&linkCode=ur2&linkId=9dc4a4f9e26ed16b3d10606d082063f2&camp=1789&creative=9325'">
									{{ asinRelated.product_title || asinRelated.title }}
								</a>
							</el-tooltip>
					</div>
					<div style="font-size: 12px;">
						<div>
							<font v-if="asinRelated.list_price" style="font-weight: bolder;" color="#F56C6C" size="4">
                                {{ getSymbolByCurrency(asinRelated.list_price[0].currency) }}{{ asinRelated.list_price[0].value }}
							</font>
							<font size="4" v-else> -- </font>
						</div>
                        <div class="asin-top-data" />
                        <div style="font-size: 9px;" v-if="asinRelated.sales_ranks && (asinRelated.sales_ranks[0].displayGroupRanks.length > 0 || asinRelated.sales_ranks[0].classificationRanks.length > 0)">
                            <div v-for="(item, index) in asinRelated.sales_ranks[0].displayGroupRanks" :key="'displayGroupRanks' + index">
                                <font style="background: rgb(147, 217, 109);">#{{item.rank}}</font> in <a target="_blank" :href="item.link"> {{ item.title }}</a>
                            </div>
                            <div v-for="(item, index) in asinRelated.sales_ranks[0].classificationRanks" :key="'classificationRanks' + index">
                                <font style="background: rgb(147, 217, 109);">#{{item.rank}}</font> in <a target="_blank" :href="item.link"> {{ item.title }}</a>
                            </div>
                            <div class="asin-top-data" />
                        </div>
                        <div style="font-size:12px; margin-bottom: 5px;">
							<copy-sub placement="top" v-if="clickType === 'copy'" :value="asinRelated.asin " content="点击复制">
								<a class="underline-dashed-line" style="margin-right: 5px;">{{ asinRelated.asin }}</a>
							</copy-sub>

							<el-tooltip v-else effect="light" placement="top" :content="'点击查询该ASIN相关的关键词的数据'">
								<a class="underline-dashed-line" style="margin-right: 5px;" @click="click_asin()">{{ asinRelated.asin }}</a>
							</el-tooltip>

							<el-tooltip v-if="clickType === 'copy'" effect="light"
								placement="top" :content="'点击查询该ASIN相关的关键词的数据'">
								<i class="el-icon-search" @click="click_asin()" style="font-weight: bolder;cursor: pointer"></i>
							</el-tooltip>

							<copy-sub v-else :value="asinRelated.asin"></copy-sub>

							<el-tooltip effect="light" placement="top" :content="'在亚马逊中打开'">
								<a target="_blank"
									:href="'https://www.'+ getCountryObjByCity(country).department +'/dp/' + asinRelated.asin + '?&_encoding=UTF8&tag=yuzone00-20&linkCode=ur2&linkId=9dc4a4f9e26ed16b3d10606d082063f2&camp=1789&creative=9325'"
									style="margin-left: 5px;">
									<i class="el-icon-paperclip"></i>
								</a>
							</el-tooltip>
						</div>                        
                        <div class="overflow-one-line" style="width:250px">
							类目:
							<el-tooltip v-if="asinRelated.summaries" effect="light" :content="asinRelated.summaries[0].browseClassification ? asinRelated.summaries[0].browseClassification.displayName : ''" placement="top-end">
								<span v-if="asinRelated.summaries[0].browseClassification">
									{{ asinRelated.summaries[0].browseClassification.displayName }}
								</span>
                                <span v-else> -- </span>
							</el-tooltip>
						</div>                        
						<div>
							品牌:
							<el-tooltip v-if="asinRelated.summaries" effect="light" :content="asinRelated.summaries[0].brand ? asinRelated.summaries[0].brand : ''" placement="top-end">
								<span v-if="asinRelated.summaries[0].brand">
									{{ asinRelated.summaries[0].brand }}
								</span>
                                <span v-else> -- </span>
							</el-tooltip>
						</div>
						<div class="overflow-one-line" style="width:250px">
							卖家:
							<el-tooltip v-if="asinRelated.summaries" effect="light" :content="asinRelated.summaries[0].manufacturer ? asinRelated.summaries[0].manufacturer : ''" placement="top-end">
								<span v-if="asinRelated.summaries[0].manufacturer">
									{{ asinRelated.summaries[0].manufacturer }}
								</span>
                                <span v-else> -- </span>
							</el-tooltip>
						</div>
                        <div class="overflow-one-line" style="width:250px">
							规格:
                            <el-tooltip v-if="asinRelated.summaries" effect="light" :content="(asinRelated.summaries[0].size ? asinRelated.summaries[0].size : '--') +' / '+ (asinRelated.summaries[0].color ? asinRelated.summaries[0].color : '--') +' / '+ (asinRelated.summaries[0].style ? asinRelated.summaries[0].style : '--')" placement="top-end">
								<span v-if="asinRelated.summaries[0].color || asinRelated.summaries[0].size || asinRelated.summaries[0].style">
									{{ asinRelated.summaries[0].size ? asinRelated.summaries[0].size : '--' }} / {{ asinRelated.summaries[0].color ? asinRelated.summaries[0].color : '--' }} / {{ asinRelated.summaries[0].style ? asinRelated.summaries[0].style : '--' }}
                                </span>
                                <span v-else> -- </span>
                            </el-tooltip>
						</div>
                        <div>
							日期:
								<span v-if="asinRelated.summaries && asinRelated.summaries[0].releaseDate">
									{{ asinRelated.summaries[0].releaseDate }}
                                </span>
                                <span v-else> -- </span>
						</div>
						<div class="share-box-div" v-if="asinRelated.click_share">
							<div v-if="asinRelated.click_share">
								<div>
									点击占比:
									<font class="font-weight">
										{{ toPercent(asinRelated.click_share, 2) }}
									</font>
								</div>
								<div>
									转化占比:
									<font class="font-weight">
										{{ toPercent(asinRelated.conversion_share, 2) }}
									</font>
								</div>
							</div>
<!--							<div v-if="asinRelated.conversion_share">-->
<!--								平均转化:-->
<!--								<font v-if="asinRelated.conversion_share / asinRelated.click_share > 1" color="#389e0d">-->
<!--									高-->
<!--									({{ changeDecimal(asinRelated.conversion_share / asinRelated.click_share, 2) }})-->
<!--								</font>-->
<!--								<font color="#F56C6C"-->
<!--									v-else-if="asinRelated.conversion_share / asinRelated.click_share == 1">-->
<!--									平-->
<!--									({{ changeDecimal(asinRelated.conversion_share / asinRelated.click_share, 2) }})-->
<!--								</font>-->
<!--								<font v-else color="#faad14">-->
<!--									低-->
<!--									({{ changeDecimal(asinRelated.conversion_share / asinRelated.click_share, 2) }})-->
<!--								</font>-->
<!--							</div>-->
						</div>
					</div>
				</div>

				<div style="width: 340px;margin-left: 20px;border-left: 1px solid #DCDFE6;padding-left: 10px">
<!--					<div style="font-weight: bolder;border-bottom: 1px solid #f0f0f0;padding-bottom: 5px">-->
<!--						<span class="default-font-color">上榜数据&nbsp;</span>-->
<!--						-->
<!--					</div>-->
					<el-table :data="tableData" height="275px" v-loading="tableLoading" :key="tableData.length">
						<el-table-column width="210px"  align="center">
							<template slot="header">
								日期 <span class="emphasis-hint" v-if="tableTotal">({{ tableTotal }})</span>
							</template>
							<template slot-scope="scope">{{  fomatTimeStr(scope.row.date) }}</template>
						</el-table-column>
						<el-table-column label="点击转化" width="80px" align="right" header-align="right">
							<template slot-scope="scope">
								<div style="font-size: 12px; line-height: 16px; text-align: right;">
									{{void (obj=scope.row.clicked_asin.find(i => i.asin === asinRelated.asin)) }}
									<div>{{ toPercent(obj.click_share) }}</div>
									<div>{{ toPercent(obj.conversion_share) }}</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="排名" width="50px" align="center">
							<template slot-scope="scope">
								{{ scope.row.clicked_asin.findIndex(i => i.asin === asinRelated.asin) + 1 }}
							</template>
						</el-table-column>
					</el-table>

				</div>
			</div>
		</div>

		<div class="img-div" slot="reference" @mouseenter="openPopper">
			<slot>
				<div v-if="thumbnailLazy">
					<el-image style="width:100%; height:100%;" lazy
						:src="fomatThumbnail(asinRelated.images ? asinRelated.images[0].link.replace('.jpg','._SL100_.jpg') : '')" fit="contain">
						<div slot=placeholder>
							<i class="el-icon-loading"></i>
						</div>
					</el-image>
				</div>
				<div v-else>
					<i class="el-icon-loading"></i>
				</div>
			</slot>
			<!-- <i class="el-icon-picture-outline"></i> -->
		</div>
	</el-popover>
</template>

<script>
import COPY_SUB from '@/components/template/otherSub/copySub.vue'
import { changeDecimal, toPercent, toThousands } from '@/components/common/utils/fomatNum.js'
import { getCountryObjByCity, getSymbolByValue, getSymbolByCurrency } from '@/components/config/countryCodeConfig.js'
import { imgSizeSet } from "@/components/common/utils/imgUtils";
import { fomatTimeStr } from "@/components/common/utils/time";
import { api_getAsinTrendByKeyword_public } from "@/components/api/keywordReverseSearch";
import REFRESH_ASIN_SUB from "@/components/template/view/sub/asin/refreshAsinData";
import A from '../../a.vue';

export default {
	name: 'asinInfoSubV1',
	inject: ['F_alertMsg', 'F_windowLoading', 'F_getErrMSg'],
	data() {
		return {
			value1: 4,
			loading: false,
			tableLoading : true,
			clickType: localStorage.getItem("weeklyClickType"),
			colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
			buyBox: {},
			imgLoading: false,
			tableData : [],
			tableTotal : 0,
		}
	},
	props: {
		thumbnailLazy : {
			default: false
		},
		asinRelated: {
			required: true
		},
		keywords : {
			required:  true
		},
		country: {
			default :'US'
		}
	},
	mounted() {},
	components: {
		'copy-sub': COPY_SUB,
		'refresh-sub' : REFRESH_ASIN_SUB,
A
	},
	created() {
	},
	methods: {
		openPopper : function() {
			this.$refs.dcPopover.updatePopper()
		},
		showPopper : function() {
			this.$data.imgLoading=true
			if (this.$data.tableData.length <= 0){
				this.$options.methods.loadAsinTrends(this)
			}
		},
		loadAsinTrends : function(this_) {
			this_ = this_ || this
			let pa = { asin : this_.asinRelated.asin,keyword : this_.keywords ,country : this_.country }
			api_getAsinTrendByKeyword_public(pa).then(res => {
				this_.$data.tableData = res.data
				this_.$data.tableTotal = res.data.length
				// 关闭遮罩
				this_.$data.tableLoading = false
			}).catch(err => {
				// 关闭遮罩
				this_.$data.tableLoading = false
				this_.F_alertMsg(this_.F_getErrMSg(err, '加载失败，请重新尝试'), 4)
			})
		},
		fomatTimeStr: function(date) {
			return fomatTimeStr(date)
		},
		fomatThumbnail: function(url) {
			return imgSizeSet(url,80);
		},
		click_asin: function() {
			this.$emit('clickAsin', this.asinRelated.asin)
		},
		toThousands: function(val) {
			return toThousands(val)
		},
		getSymbolByValue: function(val) {
			return getSymbolByValue(val)
		},
        getSymbolByCurrency: function(val) {
            return getSymbolByCurrency(val)
        },
		getCountryObjByCity: function(val) {
			return getCountryObjByCity(val)
		},
		changeDecimal: function(v, d) {
			return changeDecimal(v, d)
		},
		toPercent : function(val,n=2) {
			return toPercent(val,n)
		}
	},
	watch: {
	},
}
</script>

<style scoped>
.asin-data-div {

}

.big-img-div {
	padding: 5px;
	border: 1px solid #E4E7ED;
	text-align: center;
	position: relative;
	width: 275px;
	height: 275px;
	line-height: 275px;
}

.big-img-div .star-div {
	position: absolute;
	left: 0px;
	bottom: 20px;
	background-color: rgba(192, 196, 204, 0.5);
	padding: 5px;
	/* opacity: 0.5; */
}

.big-img-div .ranking-div {
	position: absolute;
	right: 5px;
	top: 10px;
	background-color: #E6A23C;
	height: 25px;
	width: 25px;
	text-align: center;
	line-height: 25px;
	font-size: 13px;
	border-radius: 50%;
	font-weight: bolder;
	color: #FFFFFF;
}

.big-img-div .mode-div {
	position: absolute;
	top: 0px;
	bottom: 0px;
	left: 0px;
	right: 0px;
	text-align: center;
	line-height: 210px;
	font-size: 3rem;
	user-select: none;
	font-weight: bolder;
	color: rgba(255, 255, 255, 0.5);
	text-shadow: 0px 0px 2px 2px #000000;
}

.img-div {
	width: 80px;
	height: 80px;
	padding: 5px;
	line-height: 70px;
	text-align: center;
	border: 1px #DCDFE6 solid;
	border-radius: 4px;
	cursor: pointer;
	box-sizing:border-box;
}

.img-div:hover {
	border: 1px solid #E6A23C;
}

.left-text-div {
	width: 50%;
	float: left;
}

.asin-title-div {
	/*text-overflow: -o-ellipsis-lastline;*/
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	line-clamp: 2;
	-webkit-box-orient: vertical;
	/* margin-bottom: 10px; */
	font-size: 12px;
	font-weight: bolder;
	/* min-height: 45px; */
}

.asin-text-div {
	margin-top: 10px;
}

.asin-top-data {
	border-bottom: 1px solid #DCDFE6;
	padding-bottom: 5px;
	margin-bottom: 5px;
}

.share-box-div {
	margin-top: 5px;
	padding-top: 5px;
	border-top: 1px solid #DCDFE6;
}
</style>
<style>
.el-start-i-202206210501 {
	float: left;
	/* margin-right: 5px; */
}

.el-start-i-202206210501 .el-rate__icon {
	margin: 0px;
}

</style>